export default {
    C : [{
        name: '长安镇',
        id : 'ChangAnZhen'
    },
    {
        name: '常平镇',
        id : 'ChangPingZhen'
    },
    {
        name: '茶山镇',
        id : 'ChaShanZhen'
    }],
    D : [{
        name: '东城街道',
        id : 'DongChengJieDao'
    },
    {
        name: '道滘镇',
        id : 'DaoJiaoZhen'
    },
    {
        name: '东坑镇',
        id : 'DongKengZhen'
    },
    {
        name: '大岭山镇',
        id : 'DaLingShanZhen'
    },
    {
        name: '大朗镇',
        id : 'DaLangZhen'
    }],
    F : [{
        name: '凤岗镇',
        id : 'FengGangZhen'
    }],
    G : [{
        name: '高埗镇',
        id : 'GaoBuZhen'
    },
    {
        name: '莞城街道',
        id : 'GuanChengJieDao'
    }],
    H : [{
        name: '黄江镇',
        id : 'HuangJiangZhen'
    },
    {
        name: '厚街镇',
        id : 'HouJieZhen'
    },
    {
        name: '横沥镇',
        id : 'HengLiZhen'
    },
    {
        name: '虎门镇',
        id : 'HuMenZhen'
    },
    {
        name: '洪梅镇',
        id : 'HongMeiZhen'
    },
    {
        name: '惠州国汇山店',
        id : 'HuiZhouGuoHuiShan'
    }],
    L : [{
        name: '寮步镇',
        id : 'LiaoBuZhen'
    }],
    M : [{
        name: '麻涌镇',
        id : 'MaChongZhen'
    }],
    N : [{
        name: '南城街道',
        id : 'NaChengJieDao'
    }],
    Q : [{
        name: '企石镇',
        id : 'QiShiZhen'
    },
    {
        name: '桥头镇',
        id : 'QiaoTouZhen'
    },
    {
        name: '清溪镇',
        id : 'QingXiZhen'
    }],
    S : [{
        name: '石碣镇',
        id : 'ShiJieZhen'
    },
    {
        name: '石龙镇',
        id : 'ShiLongZhen'
    },
    {
        name: '石排镇',
        id : 'ShiPaiZhen'
    },
    {
        name: '松山湖',
        id : 'SongShanHu'
    },
    {
        name: '沙田镇',
        id : 'ShaTianZhen'
    }],
    T: [{
        name: '塘厦镇',
        id : 'TangXiaZhen'
    }],
    W: [{
        name: '万江街道',
        id : 'WanJiangJieDao'
    },
    {
        name: '望牛墩镇',
        id : 'WangNiuDunZhen'
    }],
    X: [{
        name: '谢岗镇',
        id : 'XieGangZhen'
    }],
    Z: [{
        name: '樟木头镇',
        id : 'ZhangMuTouZhen'
    },
    {
        name: '中堂镇',
        id : 'ZhongTangZhen'
    }],

}


// WEBPACK FOOTER //
// ./src/assets/City/city.js